import type { UserRole } from '~/api/types';
import { buildTestId } from '~/utils/buildTestId';

import { USER_ROLES, type UserRoleValue } from '../auth/roles';

export const DEPARTMENT_TABS = {
  profile: 0,
  settings: 1,
  patientAlerts: 2,
  alertDefaults: 3,
} as const;

const DEPARTMENT_TABS_LABEL: Record<
  (typeof DEPARTMENT_TABS)[keyof typeof DEPARTMENT_TABS],
  string
> = {
  [DEPARTMENT_TABS.profile]: 'Dept Profile',
  [DEPARTMENT_TABS.settings]: 'General Settings',
  [DEPARTMENT_TABS.patientAlerts]: 'Patient Alerts',
  [DEPARTMENT_TABS.alertDefaults]: 'Alert Defaults',
} as const;

export type DepartmentTabsValue =
  (typeof DEPARTMENT_TABS)[keyof typeof DEPARTMENT_TABS];

const DEPARTMENT_TABS_BY_ROLE: Record<UserRoleValue, DepartmentTabsValue[]> = {
  [USER_ROLES.HcpAdmin]: [
    DEPARTMENT_TABS.profile,
    DEPARTMENT_TABS.settings,
    DEPARTMENT_TABS.patientAlerts,
    DEPARTMENT_TABS.alertDefaults,
  ],
  [USER_ROLES.NonHcpAdmin]: [DEPARTMENT_TABS.profile, DEPARTMENT_TABS.settings],

  [USER_ROLES.AdminAbbott]: [],
  [USER_ROLES.AbbottUser]: [],
  [USER_ROLES.HcpUser]: [],
};

export const DepartmentTabsConfig = ({
  testID,
  role,
}: {
  testID: string;
  role: UserRole;
}) => {
  const allowedTabs = DEPARTMENT_TABS_BY_ROLE[role];

  return allowedTabs.map((tabValue) => {
    const label = DEPARTMENT_TABS_LABEL[tabValue];

    return {
      label,
      'aria-label': label,
      testID: buildTestId({ testID, suffix: ['tab', label] }),
      tabKey: tabValue,
    };
  });
};

export function getDepartmentTabsLength(role: UserRole | undefined) {
  if (!role) {
    return 0;
  }

  return DEPARTMENT_TABS_BY_ROLE[role].length;
}
